import React from 'react'
import Aside from './Aside'
import NewFooter from './NewFooter'
import NewNavbar from './NewNavbar'

export default function AppShell({
  page,
  expanded,
  title,
  subtitle,
  notice,
  actions,
  children,
  contentPreset = 'default',
  contentClassName = '',
}) {
  const mergedContentClassName = `app-content app-theme-content app-theme-content--${contentPreset} ${contentClassName}`.trim()

  return (
    <div className="app app-theme-shell">
      <div id="app">
        <div className="main-wrapper app-theme-wrapper">
          <Aside page={page} expanded={expanded} />
          <div className="app-theme-main">
            <NewNavbar />
            <div className={mergedContentClassName}>
              {(title || subtitle || actions) && (
                <>
                  <section className="app-page-head">
                    <div className="app-page-head__copy">
                      {title && <h1>{title}</h1>}
                      {subtitle && <p>{subtitle}</p>}
                    </div>
                    {actions && <div className="app-page-head__actions">{actions}</div>}
                  </section>
                  {notice && <div className="app-page-head__notice">{notice}</div>}
                </>
              )}
              <div className="app-page-body">{children}</div>
            </div>
            <NewFooter />
          </div>
        </div>
      </div>
    </div>
  )
}